import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors, FiltersSelected, CustomComponent } from "@usereactify/search";

import { Search } from "@app/scripts/reactify/search/components/Search";
import { isKids, tagFilterKids, tagFilterMens } from "@app/scripts/utils/tagFilters";

if (window.location.pathname.startsWith("/search")) {
  const isKidsOnly = isKids();

  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "search",
    additionalComponentIds: ["TagFilter"],
  });

  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <CustomComponent
          componentId="TagFilter"
          customQuery={() => ({
            query: {
              ...(isKidsOnly ? tagFilterKids : tagFilterMens),
            },
          })}
        />
        <FiltersSelected
          render={props => {
            const flattenedFilters = props?.selectedFilters
              ?.map(item => {
                if (item?.key === "price") return { key: item?.key, value: item?.value?.join(" - ") }
                if (typeof item?.value === "object") return item?.value?.map(value => ({ key: item?.key, value }))
                return item
              })
              ?.flat()
            return <></>
          }}
        />
        <Sensors />
        <Search />
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
